<p class="ai-notice">{{ text() }}</p>
